(function () {
  'use strict';

  function initAccordion(sectionEl) {
    var items = Array.from(sectionEl.querySelectorAll('[data-accordion-item]'));
    if (!items.length) return;

    /* Find the main feature image element for swapping */
    var mediaEl  = sectionEl.querySelector('[data-feature-media]');
    var mainImg  = mediaEl ? mediaEl.querySelector('.pdp-scent-accordion__feature-img') : null;
    var defaultImg = mediaEl ? mediaEl.dataset.defaultImg : '';

    function getPanel(item) {
      return item.querySelector('.pdp-scent-accordion__panel');
    }

    /**
     * Swap the main feature image to the src stored on `item[data-feature-img]`.
     * Uses a quick opacity crossfade so the swap isn't jarring.
     */
    function swapMainImage(item) {
      if (!mainImg) return;
      var newSrc = item.dataset.featureImg || defaultImg;
      if (!newSrc || mainImg.src === newSrc) return;

      /* Pre-load the incoming image before starting the fade-out — this
         ensures the swap is instant once the fade-out completes, eliminating
         any blank-frame flicker on cache-miss. */
      var preload = new Image();
      preload.onload = function () {
        mainImg.classList.add('pdp-scent-accordion__feature-img--fade');
        mainImg.addEventListener('transitionend', function onFaded() {
          mainImg.removeEventListener('transitionend', onFaded);
          mainImg.src = newSrc;
          mainImg.classList.remove('pdp-scent-accordion__feature-img--fade');
        }, { once: true });
      };
      /* If the image fails to load, fall through gracefully */
      preload.onerror = function () {
        mainImg.src = newSrc;
      };
      preload.src = newSrc;
    }

    function openItem(item) {
      /* Close every other item */
      items.forEach(function (el) {
        if (el === item) return;
        el.classList.remove('pdp-scent-accordion__item--open');
        var btn   = el.querySelector('.pdp-scent-accordion__trigger');
        var panel = getPanel(el);
        if (btn)   btn.setAttribute('aria-expanded', 'false');
        if (panel) panel.style.maxHeight = '0';
      });

      /* Open the target item */
      item.classList.add('pdp-scent-accordion__item--open');
      var trigger = item.querySelector('.pdp-scent-accordion__trigger');
      var panel   = getPanel(item);
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (panel)   panel.style.maxHeight = (panel.scrollHeight + 10) + 'px';

      /* Swap the main image to this ingredient's image */
      swapMainImage(item);
    }

    function closeItem(item) {
      item.classList.remove('pdp-scent-accordion__item--open');
      var trigger = item.querySelector('.pdp-scent-accordion__trigger');
      var panel   = getPanel(item);
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel)   panel.style.maxHeight = '0';
    }

    /* ---- Set initial panel heights from the --open class applied by Liquid ---- */
    /* NOTE: We intentionally do NOT set mainImg.src here.
       The Liquid template already renders the first ingredient's image as the
       initial src (see pdp-scent-accordion.liquid), so no JS swap is required
       on load — eliminating the default-image flash on cold cache. */
    items.forEach(function (item) {
      var panel = getPanel(item);
      if (!panel) return;
      if (item.classList.contains('pdp-scent-accordion__item--open')) {
        panel.style.maxHeight = (panel.scrollHeight + 10) + 'px';
      } else {
        panel.style.maxHeight = '0';
      }
    });

    /* ---- Click listeners ---- */
    items.forEach(function (item) {
      var trigger = item.querySelector('.pdp-scent-accordion__trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        if (item.classList.contains('pdp-scent-accordion__item--open')) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.pdp-scent-accordion').forEach(initAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when the Shopify theme editor reloads the section */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.pdp-scent-accordion');
    if (section) initAccordion(section);
  });
})();